import { AxiosResponse } from 'axios';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { SWRConfig } from 'swr';
import App from './App';
import { http } from './lib/http';
import reportWebVitals from './reportWebVitals';
import store from './store/store';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <SWRConfig
        value={{
          fetcher: (url: string, params: any) =>
            http.get(url, { params }).then((res: AxiosResponse) => res.data)
        }}>
        <App />
        <ToastContainer />
      </SWRConfig>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
